// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--OcOvM","list":"list--sfML1"};